import styled from 'styled-components'

export const LayoutContainer = styled.div`
  background-color: white;

  @media (max-width: 550px) {
    /* Phones */
    font-size: 0.9em;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    font-size: 0.9em;
  }
`

export const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`

export const ContentContainer = styled.div`
  background-color: white;
  min-height: 60vh;
`
 
export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const FooterContainer = styled.div`
  color: white;
  display: grid;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
  background-image: linear-gradient(rgba(40, 44, 52, 1), rgba(0, 0, 1, 1));
`

export const JoinTeamComponent = styled.div`
  background-color: #F2F2F2;
`

export const SectionsContainer = styled.div`
  background-image: linear-gradient(rgba(40, 44, 52, 1), rgba(0, 0, 1, 1));
  width: 100%;
`

export const AboutContent = styled.div`

`

export const ContainerProduct = styled.div`
  display: flex;
  background: #0d1120;
  color: white;
  height: 90vh;
`;

export const EuphaWorldContainer = styled.div`
  height: 100%;
  width: 100%;
  /* temporarily set the background color so we can tell where the map container is positioned */
  background-color: lightgrey;
`